<template>
    <div class="table-responsive p-0">
        <table class="table main-table">
            <thead>
                <tr>
                    <th class="text-center">
                        <input type="checkbox">
                    </th>
                    <th>Name </th>
                    <th>UserName</th>
                    <th>Wallet Balance </th>
                    <th>Date Created </th>
                    <th>Actions</th>
                    <th>Availability </th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="subRetailerUsersLoading">
                    <td colspan="5">
                        <div class="text-center">
                            <Vue3Lottie :animationData="searchingJSON" class="height-150 py-2" />
                        </div>
                    </td>
                </tr>
                <tr v-if="!subRetailerUsersLoading && subRetailerUsers.length == 0">
                    <td colspan="5">
                        <div class="text-center">
                            <Vue3Lottie :animationData="noDataJSON" class="height-150 py-2" />
                            <p class="text-xs font-weight-bold">No Data Found</p>
                        </div>
                    </td>
                </tr>
                <tr v-for="(subRetailerUser, i) in subRetailerUsers" :key="i">
                    <td class="text-center">
                        <input type="checkbox">
                    </td>
                    <td>
                        <div class="d-flex flex-column justify-content-center">
                            <p class="main-text"> {{ subRetailerUser.name }}</p>
                        </div>
                    </td>
                    <td>
                        <p class="sub-text"> {{ subRetailerUser.username }}</p>
                    </td>
                    <td>
                        <div class="icon-container-action d-flex align-items-center"
                            @click="showSubRetailerUserBalance(subRetailerUser)">
                            <img src="/img/top-up.png" class="me-2" alt="logo" />
                            {{ subRetailerUser.balance.toLocaleString('en-PH') }}
                        </div>
                    </td>
                    <td> {{ $format.FormatFullDateTime(subRetailerUser.timestamp) }} </td>
                    <td>
                        <div class="icon-container-action" data-toggle="tooltip" data-original-title="Edit user"
                            @click="showSubRetailerUserDetail(subRetailerUser)">
                            <img src="/img/updatedark.png" alt="logo" />
                        </div>
                    </td>
                    <td>
                        <label class="switch">
                            <input type="checkbox" v-model="subRetailerUser.isActive"
                                @change="handleChange(subRetailerUser)" />
                            <span class="slider round"></span>
                        </label>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <subRetailerUserDetail />
    <subRetailerUserBalance />
    <GlobalModal :show="modal.show" :type="modal.type" :title="modal.title" :message="modal.message"
        @close="modal.show = false" @confirm="handleModalConfirm" @cancel="handleModalCancel" />
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import noDataJSON from "./../../../assets/no-data.json";
import searchingJSON from "./../../../assets/searching.json";
import subRetailerUserDetail from "./../../subRetailersView/components/subRetailerUserDetail.vue"
import subRetailerUserBalance from "./../../subRetailersView/components/subRetailerUserBalance.vue"
import GlobalModal from "@/components/GlobalModal.vue";

export default {
    components: {
        subRetailerUserDetail,
        subRetailerUserBalance,
        GlobalModal,
    },
    data() {
        return {
            noDataJSON,
            searchingJSON,
            subRetailerUsersAll: [],
            modal: { show: false, type: 'success', title: '', message: '', confirmAction: null, cancelAction: null, context: null, }
        };
    },
    computed: {
        ...mapState({
            subRetailerUsersLoading: (state) => state.retailerController.subRetailerUsersLoading,
            subRetailerUsers: (state) => state.retailerController.filteredSubRetailersUser,
            showSubRetailerUserDetailSidebar: (state) =>
                state.retailerController.showSubRetailerUserDetailSidebar,
        }),
    },
    methods: {

        ...mapActions({
            getSubRetailerUsers: "retailerController/GetSubRetailerUsers",
            updateSubRetailerUserVisibility:
                "retailerController/UpdateSubRetailerUserVisibility",
        }),
        ...mapMutations({
            setShowSubRetailerUserDetailSidebar:
                "retailerController/SET_ShowSubRetailerUserDetailSidebar",
            selectSubRetailer: "retailerController/SELECT_SubRetailer",
            selectSubRetailerUser: "retailerController/SELECT_SubRetailerUser",
            showSubRetailerUserBalanceSidebar:
                "retailerController/SET_ShowSubRetailerUserBalanceSidebar",
        }),
        notImplemented() {
            alert("not yet implemented.");
        },
        showSubRetailerUserDetail(subRetailerUser) {
            this.selectSubRetailerUser(subRetailerUser);
            this.setShowSubRetailerUserDetailSidebar(true);
        },

        showSubRetailerUserBalance(subRetailerUser) {
            this.selectSubRetailerUser(subRetailerUser);
            this.showSubRetailerUserBalanceSidebar(true);
        },

        async handleChange(subRetailerUser) {
            this.showModal(
                'confirmation',
                'Change User Visibility',
                `Are you sure you want to ${subRetailerUser.isActive ? 'activate' : 'deactivate'} this user?`,
                async () => {
                    await this.updateSubRetailerUserVisibility({
                        subRetailerUserID: subRetailerUser.subRetailerUserID,
                        isVisible: subRetailerUser.isActive,
                    }).then((response) => {
                        this.showModal('success', 'Success', `User ${subRetailerUser.name} was ${subRetailerUser.isActive ? 'activate' : 'deactivate'}!`);
                    }).catch((err) => {
                        this.showModal('error', 'Failed', err.response?.data?.ErrorMessage || 'Error updating visibility');
                        subRetailerUser.isActive = !subRetailerUser.isActive;
                    });
                },
                () => { subRetailerUser.isActive = !subRetailerUser.isActive; },
                subRetailerUser,
            );
        },
        showModal(type, title, message, confirmAction, cancelAction, context) {
            this.modal = { show: true, type, title, message, confirmAction, cancelAction, context };
        },
        async handleModalConfirm() {
            if (typeof this.modal.confirmAction === 'function') { await this.modal.confirmAction(); }
        },
        handleModalCancel() {
            if (typeof this.modal.cancelAction === 'function') { this.modal.cancelAction(); }
        },
    },
    async mounted() {
        const subRetailerID = localStorage.getItem("userSubRetailerID");
        if (subRetailerID) {
            await this.getSubRetailerUsers(parseInt(subRetailerID));
        }
    },
};
</script>

<style scoped>
/* The switch - the box around the slider */
.switch {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 25px;
}

/* Hide default HTML checkbox */
.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

/* The slider */
.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: 0.4s;
    transition: 0.4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
}

input:checked+.slider {
    background-color: #2196f3;
}

input:focus+.slider {
    box-shadow: 0 0 1px #2196f3;
}

input:checked+.slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
    border-radius: 34px;
}

.slider.round:before {
    border-radius: 50%;
}
</style>